<template>
  <div class="download-page-item">
    <NuxtLink :to="link" class="download-page-item__inner">
      <div class="download-page-item__image-holder">
        <img v-if="resources" :src="baseUrlMedia + resources[0].fileId + '/' + resources[0].fileName" :alt="resources[0].fileName" />
      </div>
      <div class="download-page-item__content">
        <b class="download-page-item__title">{{ title }}</b>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { storeToRefs } from 'pinia';

  interface Resource {
    fileId: string;
    fileName: string;
  }

  const props = defineProps<{
    title?: string;
    img?: string;
    resources?: Resource[];
    link?: string;
  }>();

  const mainStore = useMainStore();
  const { baseUrlMedia } = storeToRefs(mainStore);
</script>
